import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Typography, Spin, Input, InputNumber, Button, Tabs, notification, Switch } from 'antd';
import './BookingSubCategoryModal.css';

const { Text } = Typography;
const { Search } = Input;
const { TabPane } = Tabs;

@inject(
    'CmsLanguageStore',
    'BookingSubCategoryStore',
)
@observer
class BookingSubCategoryModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
        this.props.CmsLanguageStore.getActives();
    }

    // ON CHANGE

    nameEnglishOnChange = (e) => {
        this.props.BookingSubCategoryStore.setNameEnglish(e.target.value);
    }

    nameChineseOnChange = (e) => {
        this.props.BookingSubCategoryStore.setNameChinese(e.target.value);
    }

    nameChineseTraditionalOnChange = (e) => {
        this.props.BookingSubCategoryStore.setNameChineseTraditional(e.target.value);
    }

    nameThaiOnChange = (e) => {
        this.props.BookingSubCategoryStore.setNameThai(e.target.value);
    }

    nameJapaneseOnChange = (e) => {
        this.props.BookingSubCategoryStore.setNameJapanese(e.target.value);
    }

    nameVietnameseOnChange = (e) => {
        this.props.BookingSubCategoryStore.setNameVietnamese(e.target.value);
    }

    capacityOnChange = (value) => {
        this.props.BookingSubCategoryStore.setCapacity(value);
    }

    isAvailableOnChange = (value) => {
        this.props.BookingSubCategoryStore.setIsAvailable(value);
    }

    maxHourPerDayOnChange = (value) => {
        this.props.BookingSubCategoryStore.setMaxHourPerDay(value);
    }

    sortOrderOnChange = (value) => {
        this.props.BookingSubCategoryStore.setSortOrder(value);
    }

    // ON Search

    bookingCategoryOnSearch = () => {
        this.props.BookingSubCategoryStore.setBookingCategorySearchValue('');
        this.props.BookingSubCategoryStore.searchBookingCategory();
        this.props.BookingSubCategoryStore.setShowBookingCategorySearchModal(true);
    }

    // ON CLICK

    createOrUpdateBookingSubCategoryDetailOnClick = () => {
        this.props.BookingSubCategoryStore.createOrUpdateBookingSubCategoryDetail();
    }

    initUpdateBookingSubCategoryDetailOnClick = (bookingSubCategoryDetailId) => {
        this.props.BookingSubCategoryStore.initUpdateBookingSubCategoryDetail(bookingSubCategoryDetailId);
    }

    cancelBookingSubCategoryDetailOnClick = () => {
        this.props.BookingSubCategoryStore.cancelBookingSubCategoryDetail();
    }

    deleteBookingSubCategoryDetailOnClick = (bookingSubCategoryDetailId) => {
        this.props.BookingSubCategoryStore.deleteBookingSubCategoryDetail(bookingSubCategoryDetailId);
    }

    createOrUpdateBookingSubCategoryOnClick = () => {
        const { id } = this.props.BookingSubCategoryStore;
        if (id === 0) {
            this.props.BookingSubCategoryStore.createBookingSubCategory().then(response => {
                if (response.isSuccess) {
                    notification['success']({
                        message: 'Success',
                        description: 'Booking Sub Category has been successfully created.',
                        duration: 3
                    });
                } else {
                    notification['error']({
                        message: 'Error',
                        description: `${response.error}`,
                        duration: 3
                    });
                }
            });
        } else {
            this.props.BookingSubCategoryStore.updateBookingSubCategory().then(response => {
                if (response.isSuccess) {
                    notification['success']({
                        message: 'Success',
                        description: 'Booking Sub Category has been successfully updated.',
                        duration: 3
                    });
                } else {
                    notification['error']({
                        message: 'Error',
                        description: `${response.error}`,
                        duration: 3
                    });
                }
            });
        }
    }

    // ON TAB CLICK

    tabNameOnTabClick = (key) => {
        this.props.BookingSubCategoryStore.setTabNameActiveKey(key);
    }

    isLanguageIdActive = (languageId) => {
        const { activeLanguages } = this.props.CmsLanguageStore;

        if (activeLanguages) {
            const language = activeLanguages.find(fi => fi.id === languageId);
            if (language) {
                return true;
            }
        }

        return false;
    }

    render() {
        const { activeLanguages } = this.props.CmsLanguageStore;

        const {
            bookingCategoryName,
            tabNameActiveKey,
            nameEnglish,
            nameChinese,
            nameChineseTraditional,
            nameThai,
            nameJapanese,
            nameVietnamese,
            capacity,
            isAvailable,
            maxHourPerDay,
            sortOrder,
            itemTextButton,
            bookingSubCategoryModalLoading
        } = this.props.BookingSubCategoryStore;

        let addOrUpdateItemDisable = false;
        if (bookingCategoryName === '' || nameEnglish === '') {
            addOrUpdateItemDisable = true;
        }

        return (
            <>
                {
                    activeLanguages
                        ?
                        <>
                            <Spin spinning={bookingSubCategoryModalLoading}>
                                <Row className='bookingsubcategorymodal-row-container'>
                                    <Col span={24} className='bookingsubcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingsubcategorymodal-col-label'>
                                                <Text className='bookingsubcategorymodal-text-label'>Category<Text className='bookingsubcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingsubcategorymodal-col-input'>
                                                <Search
                                                    placeholder='Search Category'
                                                    value={bookingCategoryName}
                                                    onSearch={this.bookingCategoryOnSearch}
                                                    enterButton
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingsubcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingsubcategorymodal-col-label-tabs'>
                                                <Text className='bookingsubcategorymodal-text-label'>Sub Category Name<Text className='bookingsubcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingsubcategorymodal-col-input'>
                                                <Tabs activeKey={tabNameActiveKey} onTabClick={this.tabNameOnTabClick}>
                                                    {/* English */}
                                                    {
                                                        this.isLanguageIdActive(1)
                                                            ?
                                                            <TabPane tab='English *' key='1'>
                                                                <Input className='bookingsubcategorymodal-input' value={nameEnglish} onChange={this.nameEnglishOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Chinese */}
                                                    {
                                                        this.isLanguageIdActive(2)
                                                            ?
                                                            <TabPane tab='简体中文' key='2'>
                                                                <Input className='bookingsubcategorymodal-input' value={nameChinese} onChange={this.nameChineseOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Chinese Traditional */}
                                                    {
                                                        this.isLanguageIdActive(3)
                                                            ?
                                                            <TabPane tab='繁體中文' key='3'>
                                                                <Input className='bookingsubcategorymodal-input' value={nameChineseTraditional} onChange={this.nameChineseTraditionalOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Thai */}
                                                    {
                                                        this.isLanguageIdActive(4)
                                                            ?
                                                            <TabPane tab='ไทย' key='4'>
                                                                <Input className='bookingsubcategorymodal-input' value={nameThai} onChange={this.nameThaiOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Japanese */}
                                                    {
                                                        this.isLanguageIdActive(5)
                                                            ?
                                                            <TabPane tab='日本' key='5'>
                                                                <Input className='bookingsubcategorymodal-input' value={nameJapanese} onChange={this.nameJapaneseOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Vietnamese */}
                                                    {
                                                        this.isLanguageIdActive(6)
                                                            ?
                                                            <TabPane tab='Vietnamese' key='6'>
                                                                <Input className='bookingsubcategorymodal-input' value={nameVietnamese} onChange={this.nameVietnameseOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }
                                                </Tabs>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingsubcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingsubcategorymodal-col-label'>
                                                <Text className='bookingsubcategorymodal-text-label'>Capacity<Text className='bookingsubcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingsubcategorymodal-col-input'>
                                                <InputNumber
                                                    className='fnbadditionalitemmodal-inputnumber-short'
                                                    min={1}
                                                    value={capacity}
                                                    onChange={this.capacityOnChange}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingsubcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingsubcategorymodal-col-label'>
                                                <Text className='bookingsubcategorymodal-text-label'>Max Hour Per Day<Text className='bookingsubcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingsubcategorymodal-col-input'>
                                                <InputNumber
                                                    className='fnbadditionalitemmodal-inputnumber-short'
                                                    min={0}
                                                    value={maxHourPerDay}
                                                    onChange={this.maxHourPerDayOnChange}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingsubcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingsubcategorymodal-col-label'>
                                                <Text className='bookingsubcategorymodal-text-label'>Sort Order<Text className='bookingsubcategorymodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingsubcategorymodal-col-input'>
                                                <InputNumber
                                                    className='fnbadditionalitemmodal-inputnumber-short'
                                                    min={0}
                                                    value={sortOrder}
                                                    onChange={this.sortOrderOnChange}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingsubcategorymodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingsubcategorymodal-col-label'>
                                                <Text className='bookingsubcategorymodal-text-label'>Is Available</Text>
                                            </Col>
                                            <Col span={16} className='bookingsubcategorymodal-col-input'>
                                                <Switch checkedChildren='Yes' unCheckedChildren='No' checked={isAvailable} onChange={this.isAvailableOnChange} />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='bookingsubcategorymodal-col-button'>
                                        <Button disabled={addOrUpdateItemDisable} type='primary' className='bookingsubcategorymodal-button' onClick={this.createOrUpdateBookingSubCategoryOnClick}>{itemTextButton}</Button>
                                    </Col>
                                </Row>
                            </Spin >
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default BookingSubCategoryModalPage;
